import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { DocumentTaxBreakdown, Mushak91, MushakForm, MushakRegister } from '../interfaces/indirectTax.interface';

const T = ENDPOINTS.INDIRECT_TAX;

export const MushakService = {
  /** True when the institution's tax profile jurisdiction is Bangladesh (offers the Mushak 6.3 button). */
  isBangladesh: async (institutionId: string): Promise<boolean> =>
    !!(await axios.get(T.MUSHAK_ELIGIBILITY(institutionId))).data?.bangladesh,
  getRegister: async (form: MushakForm, institutionId: string, from: string, to: string): Promise<MushakRegister> =>
    (await axios.get(T.MUSHAK_REGISTER(form, institutionId, from, to))).data,
  exportRegister: async (form: MushakForm, institutionId: string, from: string, to: string, format: 'xlsx' | 'csv'): Promise<Blob> =>
    (await axios.get(T.MUSHAK_REGISTER_EXPORT(form, institutionId, from, to, format), { responseType: 'blob' })).data,
  get91: async (institutionId: string, date: string): Promise<Mushak91> =>
    (await axios.get(T.MUSHAK_91(institutionId, date))).data,
  download91Pdf: async (institutionId: string, date: string): Promise<Blob> =>
    (await axios.get(T.MUSHAK_91_PDF(institutionId, date), { responseType: 'blob' })).data,
  download91Xlsx: async (institutionId: string, date: string): Promise<Blob> =>
    (await axios.get(T.MUSHAK_91_XLSX(institutionId, date), { responseType: 'blob' })).data,
  /** Per-component tax (SD / VAT ...) of a coded invoice or bill; empty components for legacy documents. */
  getDocumentTaxBreakdown: async (kind: 'sales-invoice' | 'supplier-bill', id: string): Promise<DocumentTaxBreakdown> =>
    (await axios.get(T.DOCUMENT_TAX_BREAKDOWN(kind, id))).data,
  download63Pdf: async (invoiceId: string): Promise<Blob> =>
    (await axios.get(T.MUSHAK_63_PDF(invoiceId), { responseType: 'blob' })).data,
};
